import React from "react";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th>1e persoon</th>
          <th>2e persoon</th>
          <th colSpan={2}>3e persoon</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th />
          <th />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
        </tr>
        <tr>
          <th className="col no-bor-bot">nom. ev.</th>
          <td className="no-bor-bot">
            <strong>ego</strong>
          </td>
          <td className="no-bor-bot">
            <strong>tu</strong>
          </td>
          <td className="no-bor-bot">
            <strong>is</strong>
          </td>
          <td className="no-bor-bot">
            <strong>ea</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>ik</em>
          </td>
          <td>
            <em>jij, u</em>
          </td>
          <td>
            <em>hij</em>
          </td>
          <td>
            <em>zij</em>
          </td>
        </tr>
        <tr>
          <th className="col no-bor-bot">dat. ev.</th>
          <td className="no-bor-bot">
            <strong>mihi</strong>
          </td>
          <td className="no-bor-bot">
            <strong>tibi</strong>
          </td>
          <td className="no-bor-bot">
            <strong>ei</strong>
          </td>
          <td className="no-bor-bot">
            <strong>ei</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>aan mij</em>
          </td>
          <td>
            <em>aan jou</em>
          </td>
          <td>
            <em>aan hem</em>
          </td>
          <td>
            <em>aan haar</em>
          </td>
        </tr>
        <tr>
          <th className="col no-bor-bot">acc. ev.</th>
          <td className="no-bor-bot">
            <strong>me</strong>
          </td>
          <td className="no-bor-bot">
            <strong>te</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eum</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eam</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>mij</em>
          </td>
          <td>
            <em>jou</em>
          </td>
          <td>
            <em>hem</em>
          </td>
          <td>
            <em>haar</em>
          </td>
        </tr>
        <tr>
          <th className="col no-bor-bot">abl. ev.</th>
          <td className="no-bor-bot">
            <strong>me</strong>
          </td>
          <td className="no-bor-bot">
            <strong>te</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eo</strong>
          </td>
          <td className="no-bor-bot">
            <strong>ea</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>mij</em>
          </td>
          <td>
            <em>jou</em>
          </td>
          <td>
            <em>hem</em>
          </td>
          <td>
            <em>haar</em>
          </td>
        </tr>
      </table>
    </div>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th>1e persoon</th>
          <th>2e persoon</th>
          <th colSpan={2}>3e persoon</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th />
          <th />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
        </tr>
        <tr>
          <th className="col no-bor-bot">nom. mv.</th>
          <td className="no-bor-bot">
            <strong>nos</strong>
          </td>
          <td className="no-bor-bot">
            <strong>vos</strong>
          </td>
          <td className="no-bor-bot">
            <strong>ei</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eae</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>wij</em>
          </td>
          <td>
            <em>jullie</em>
          </td>
          <td>
            <em>zij</em>
          </td>
          <td>
            <em>zij</em>
          </td>
        </tr>
        <tr>
          <th className="col no-bor-bot">dat. mv.</th>
          <td className="no-bor-bot">
            <strong>nobis</strong>
          </td>
          <td className="no-bor-bot">
            <strong>vobis</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eis</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eis</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>aan ons</em>
          </td>
          <td>
            <em>aan jullie</em>
          </td>
          <td>
            <em>aan hen</em>
          </td>
          <td>
            <em>aan hen</em>
          </td>
        </tr>
        <tr>
          <th className="col no-bor-bot">acc. mv.</th>
          <td className="no-bor-bot">
            <strong>nos</strong>
          </td>
          <td className="no-bor-bot">
            <strong>vos</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eos</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eas</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>ons</em>
          </td>
          <td>
            <em>jullie</em>
          </td>
          <td>
            <em>hen</em>
          </td>
          <td>
            <em>hen</em>
          </td>
        </tr>
        <tr>
          <th className="col no-bor-bot">abl. mv.</th>
          <td className="no-bor-bot">
            <strong>nobis</strong>
          </td>
          <td className="no-bor-bot">
            <strong>vobis</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eis</strong>
          </td>
          <td className="no-bor-bot">
            <strong>eis</strong>
          </td>
        </tr>
        <tr>
          <th className="col" />
          <td>
            <em>ons</em>
          </td>
          <td>
            <em>jullie</em>
          </td>
          <td>
            <em>hen</em>
          </td>
          <td>
            <em>hen</em>
          </td>
        </tr>
      </table>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/pers-vnw-3.js